var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import APIHelper from './APIHelper';
import { GetActiveCountryCookie } from './Helper';
/**
 * @class API
 * Handles API requests
 */
class API {
    constructor(inpBaseURL) {
        this.baseUrl = null;
        this.dont_refresh_token = false;
        this.baseUrl = inpBaseURL;
        this.internalAxios = axios.create({
            baseURL: this.baseUrl,
            headers: {
                Accept: 'application/json'
            }
        });
        // response interceptor to handle request errors
        this.initialiseResponseInterceptors();
        // response interceptor to handle out of sync countries
        this.initialiseRequestInterceptors();
    }
    initialiseResponseInterceptors() {
        this.internalAxios.interceptors.response.use((response) => {
            // return response if success
            // TODO: change to response.data to prevent redundent code
            return response;
        }, (error) => __awaiter(this, void 0, void 0, function* () {
            if (error.response && error.response.status === 401 && error.response.data.error == 'Unauthenticated.') {
                // Unauthorized - assume token is invalid.  If not trying to get a token then refresh it
                const url = error.response && error.response.request && error.response.request.responseURL;
                if (url.includes('oauth/token')) {
                    // invalid refresh token go to login
                    yield APIHelper.handleLogin({ fullPath: window.location.href, query: {} });
                    return;
                }
                else {
                    const p = APIHelper.refreshToken();
                    if (p && p instanceof Promise) {
                        return p.then((token) => __awaiter(this, void 0, void 0, function* () {
                            if (!token) {
                                // invalid refresh token go to login
                                yield APIHelper.handleLogin({ fullPath: window.location.href, query: {} });
                                return;
                            }
                            const config = error.config;
                            config.headers.Authorization = 'Bearer ' + token.accessToken;
                            return this.internalAxios.request(config);
                        })).catch((_e) => __awaiter(this, void 0, void 0, function* () {
                            // invalid refresh token go to login
                            yield APIHelper.handleLogin({ fullPath: window.location.href, query: {} });
                        }));
                    }
                    else {
                        yield APIHelper.handleLogin({ fullPath: window.location.href, query: {} });
                    }
                }
            }
            else {
                return Promise.reject(error);
            }
        }));
    }
    initialiseRequestInterceptors() {
        this.internalAxios.interceptors.request.use((config) => {
            if (config.headers.common['X-as-country-code']) {
                // Config amendment
                if (config.headers.common['X-as-country-code'] !== GetActiveCountryCookie()) {
                    //console.log('Country out of sync');
                }
            }
            return config;
        }, (error) => {
            // Error amendment
            return Promise.reject(error);
        });
    }
    getAxios() {
        return this.internalAxios;
    }
    setHeaderCommons(headerName, headerValue) {
        if (this.internalAxios)
            this.internalAxios.defaults.headers.common[headerName] = headerValue;
    }
    /**
     * @function get
     * @type async
     * @param {String} endpoint
     * Performs an axios `get` method on the API
     */
    get(endpoint, config = {}) {
        return this.internalAxios.get(endpoint, config);
    }
    /**
     * @function patch
     * @type async
     * @param {String} endpoint
     * Performs an axios `patch` method on the API
     */
    patch(endpoint, data = {}, config = {}) {
        return this.internalAxios.patch(endpoint, data, config);
    }
    /**
     * @function put
     * @type async
     * @param {String} endpoint
     * Performs an axios `get` method on the API
     */
    put(endpoint, data = {}, config = {}) {
        return this.internalAxios.put(endpoint, data, config);
    }
    /**
     * @function post
     * @type async
     * @param {String} endpoint
     * Performs an axios `post` method on the API
     */
    post(endpoint, data = {}, config = {}) {
        return this.internalAxios.post(endpoint, data, config);
    }
    /**
     * @function delete
     * @type async
     * @param {String} endpoint
     * Performs an axios `delete` method on the API
     */
    delete(endpoint, config = {}) {
        return this.internalAxios.delete(endpoint, config);
    }
    createCancelToken() {
        return axios.CancelToken.source();
    }
}
export default API;
